import { render, staticRenderFns } from "./BatchConfirmed.vue?vue&type=template&id=22d19fb4&scoped=true"
import script from "./BatchConfirmed.vue?vue&type=script&lang=js"
export * from "./BatchConfirmed.vue?vue&type=script&lang=js"
import style0 from "./BatchConfirmed.vue?vue&type=style&index=0&id=22d19fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d19fb4",
  null
  
)

export default component.exports